module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "ident pagecopyright",
    attrs: {
      "epub:type": "copyright-page",
      "id": "pagecopyright"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("InterVarsity Press, USA")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("P.O. Box 1400, Downers Grove, IL 60515, USA")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://www.ivpress.com",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ivpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }), _vm._v(" "), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "mailto:email@ivpress.com"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("email@ivpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Inter-Varsity Press, England")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("36 Causton Street, London SW1P 4ST, England")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://www.ivpbooks.com",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ivpbooks.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    staticClass: "www",
    attrs: {
      "href": "mailto:ivp@ivpbooks.com"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ivp@ivpbooks.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("©"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("2022 by Jeannine K. Brown")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jeannine K. Brown has asserted her right under the Copyright, Designs and Patents Act, 1988, to be\nidentified as Author of this work.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the publisher or the Copyright Licensing Agency.")])]), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("InterVarsity Press")]), _c('em', {
    staticClass: "italic"
  }, [_c('sup', [_vm._v("®")])]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", USA, is the book-publishing division of InterVarsity Christian Fellowship/USA")]), _c('em', {
    staticClass: "italic"
  }, [_c('sup', [_vm._v("®")])]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" and a member movement of the International Fellowship of Evangelical Students. Website: ")]), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://www.intervarsity.org",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("intervarsity.org")])]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Inter-Varsity Press, England, originated within the Inter-Varsity Fellowship, now the Universities and Colleges Christian Fellowship, a student movement connecting Christian Unions in universities and colleges throughout Great Britain, and a member movement of the International Fellowship of Evangelical Students. That historic association is maintained, and all senior IVP staff and committee members subscribe to the UCCF Basis of Faith. Website: ")]), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://www.uccf.org.uk",
      "target": "_blank"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("www.uccf.org.uk")])]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Unless otherwise stated, Scripture quotations are from The Holy Bible, New International Version (Anglicized edition). Copyright © 1979, 1984, 2011 by Biblica. Used by permission of Hodder & Stoughton Ltd, an Hachette UK company. All rights reserved. ‘NIV’ is a registered trademark of Biblica. UK trademark number 1448790.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("First published 2022")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("USA ISBN 978-1-5140-0505-7 (digital)")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("USA ISBN 978-1-5140-0504-0 (print)")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("UK ISBN 978-1-78974-267-1 (digital)")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("UK ISBN 978-1-78974-266-4 (print)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f97ef912","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781789742671_EPUB4.vue
// module id = 63
// module chunks = 0